import { render, staticRenderFns } from "./MonitoringDashboard.vue?vue&type=template&id=a6636190&scoped=true&"
import script from "./MonitoringDashboard.vue?vue&type=script&lang=js&"
export * from "./MonitoringDashboard.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringDashboard.vue?vue&type=style&index=0&id=a6636190&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6636190",
  null
  
)

export default component.exports